import { compatibilityProfileSchema } from "@wags/matchmaker/compatibility/profile-projection.contract.ts";

export const viewerCompatibilityResponseSchema = compatibilityProfileSchema;
export type ViewerCompatibilityResponseInput = Parameters<
    typeof viewerCompatibilityResponseSchema.safeParse
>[0];
